import React from 'react';
import { partial } from 'lodash';
import { SwitchItem } from '../Forms/SwitchItem';
import { SelectItem } from '../Forms/SelectItem';
import { getTranslationKey } from '../../modules/utils';
import { ICollectionsReducerState } from '../../modules/reducers';
import { FormTooltip } from '../Forms/InputTooltip';
import { useShopPricingLists } from '../../hooks/shop';

interface IProps {
  isShopActive: boolean;
  _productPricingList?: string;
  changeCallBack: (path: string, value: string | number | boolean) => void;
  hidePricingList?: boolean;
  showOnlyPurchasedPrints: boolean;
  digitalShop?: ICollectionsReducerState['digitalShop'];
  digitalChangeCallBack?: (path: string, value: string | boolean | null) => void;
}

export const ShopSettingsToggle: React.FC<IProps> = ({
  isShopActive,
  changeCallBack,
  _productPricingList,
  hidePricingList = false,
  showOnlyPurchasedPrints,
  digitalShop,
  digitalChangeCallBack
}) => {
  const {
    isDigitalUserPricingActive,
    validatedPricingListValue,
    pricingListOptions,
    digitalPricingOptions
  } = useShopPricingLists(_productPricingList);

  return (
    <div>
      <SwitchItem
        id="shopActive"
        value={isShopActive}
        changeCallback={partial(changeCallBack, 'shopActive')}
        label={getTranslationKey('collectionShop.toggleLabel')}
        direction="row-reverse"
        margin="15px 0 20px 0"
      />

      {isShopActive && !hidePricingList && (
        <SelectItem
          label={getTranslationKey('shop.selectPricingList')}
          isDefaultDisabled
          defaultOptionsText={getTranslationKey('shop.priceSelectLabel')}
          value={validatedPricingListValue}
          changeCallback={partial(changeCallBack, '_productPricingList')}
          options={pricingListOptions}
          margin={!isDigitalUserPricingActive ? '15px 0 20px 0' : ''}
        />
      )}
      {isShopActive && !hidePricingList && validatedPricingListValue && (
        <>
          {isDigitalUserPricingActive && (
            <SwitchItem
              id="showOnlyPurchasedPrints"
              value={showOnlyPurchasedPrints}
              changeCallback={partial(changeCallBack, 'showOnlyPurchasedPrints')}
              label={getTranslationKey('shop.showOnlyPurchasedPrints')}
              direction="row-reverse"
              margin="15px 0 20px 0"
              isDisabled={!isDigitalUserPricingActive}
            />
          )}
          <SelectItem
            label={getTranslationKey('collectionDigitalShop.purchasedPackage')}
            disabled={!isDigitalUserPricingActive}
            isDefaultDisabled={false}
            defaultOptionsText={getTranslationKey('shop.packageSelectLabel')}
            value={digitalShop.alreadyPurchasedTier || ''}
            changeCallback={(value) => digitalChangeCallBack('alreadyPurchasedTier', value || null)}
            options={digitalPricingOptions}
            labelActions={
              <FormTooltip
                isShow
                tooltipID="tt-alreadyPurchasedTier"
                tooltipPlacement="bottom"
                tooltipText={getTranslationKey('learnMoreLink', {
                  link: 'https://support.scrappbook.de/de/articles/61919',
                  text_link: 'https://support.scrappbook.de/de/articles/61919'
                })}
              />
            }
          />
        </>
      )}
    </div>
  );
};
